import _get from 'lodash/get';
import _castArray from 'lodash/castArray';

import { Base, Fee } from '@/models';
import { toCamelCase, omitDeep, datetimeToUTC } from '@/utilities';

export class Quotation extends Base {
  public ref: string;
  public doq: string;
  public startdate: string;
  public enddate: string;
  public validuntil: string;
  public description: string;
  public material:  Fee[];
  public labour:  Fee[];
  public mics: Fee[];
  public discount: string;
  public taxrate: string;
  public approvetoggle: boolean;



  /**
   * Constructor initialises the variables from the class Maintenancejob
   * @param data - the data to construct a type with all properties of <Maintenancejob>
   */
  public constructor(data?: Partial<Quotation>) {
    super(data);
    data = toCamelCase(data);
    this.ref = _get(data, 'ref', '');
    this.doq = _get(data, 'doq', datetimeToUTC());
    this.startdate = _get(data, 'startdate', datetimeToUTC());
    this.enddate = _get(data, 'enddate', datetimeToUTC());
    this.validuntil = _get(data, 'validuntil', datetimeToUTC());
    this.description = _get(data, 'description', '');
    this.material = _castArray(_get(data, 'material', [])).map((x: Partial<Fee>) => new Fee(x));
    this.labour = _castArray(_get(data, 'labour', [])).map((x: Partial<Fee>) => new Fee(x));
    this.mics = _castArray(_get(data, 'mics', [])).map((x: Partial<Fee>) => new Fee(x));
    this.discount = _get(data, 'discount', '');
    this.taxrate = _get(data, 'taxrate', '');
    this.approvetoggle = _get(data, 'approvetoggle', false);
  }

  /**
   * Convert class instance back into a plain old JSON object
   * and recursively remove all uuids we've add for Vue.
   *
   * @return {Object}
   */
  public toObject() {
    return omitDeep({ ...this }, ['_uuid']);
  }

  /**
  * Create a JSON representation of this object and it's descedents.
  *
  * @return {Object}
  */
  public toJSON() {
    const json = super.toJSON();
    // Convert the populated Client to the Client ID
    return {
      ...json,
    };
  }

}
